import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { FileContractIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createContractTemplate } from '../../../api/contract-template/create-contract-template'
import UserNavBar from '../../../components/elements/nav-bar'
import { ContractTemplateForm } from '../../../components/pages/contract-template/contract-template-form'
import { Paths } from '../../../lib/constants/path'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

export function ContractTemplateCreatePage() {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createContractTemplate,
    onError: showAxiosError,
    onSuccess: () => toast.success('Modèle de contrat créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer un modèle de contrat'} icon={FileContractIcon} />
      <div className={'h-4'} />
      <Box>
        <ContractTemplateForm
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(Paths.CONTRACT_TEMPLATE_UPDATE_PAGE.replace(':id', res.id.toString()), {
                replace: true
              })
            },
            onCancel: () => back(Paths.CONTRACT_TEMPLATE_LIST_PAGE)
          })}
        />
      </Box>
    </div>
  )
}
